// @flow

// Vendors
import axios from 'axios';

// Constants
import { API_URL } from '../config';

// Types
import { RequestType } from '../types';

const CancelToken = axios.CancelToken;
let cancelGetModalRequest;

export const request = async ({ data, ...options }: RequestType) => {
  try {
    const response = await axios({
      baseURL: API_URL,
      timeout: 30000,
      ...options,
      data: {
        ...data
      }
    });

    if (response.status !== 200) return Promise.reject(response);

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getModalRequest = (slug) => {
  if (cancelGetModalRequest) cancelGetModalRequest('Modal request cancelled');

  return request({
    method: 'get',
    url: `modals/${slug}`,
    cancelToken: new CancelToken((cancel) => (cancelGetModalRequest = cancel))
  });
};
